import React from 'react';
import {ArrowUpRight} from 'lucide-react';
import './discussion-sources.css';

export default function DiscussionSources({sources = [], onOpen}) {
  if (!sources.length) return null;
  const links = sources.map(source => source.sourceDeleted
    ? <span key={source.id} className="discussion-source-deleted">來源留言已刪除</span>
    : <a key={source.id} href={'/?term=' + encodeURIComponent(source.termId) + '&conversation=threads&thread=' + encodeURIComponent(source.sourceRootId)}
        onClick={event => {
          if (!onOpen || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          onOpen(source);
        }}>
        <span>源自 {source.author?.name || '未具名成員'} 的留言<span className="discussion-source-version"> · 第 {source.sourceCommentVersion} 版</span></span><ArrowUpRight size={14} aria-hidden="true"/>
      </a>);
  return sources.length === 1
    ? <div className="discussion-sources">{links}</div>
    : <details className="discussion-sources"><summary>{sources.length} 則來源留言</summary>{links}</details>;
}
